// import logo from './logo.svg';
import './App.css';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Home from './components/Home';
import Navbar from './components/Navbar';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Experience from './components/Experience';
import './styles/constant.css'
import './styles/loading.css'



function App() {


  
  return (
   <div className="overallflex">
    {/* <h1>hlooo</h1> */}

    <Navbar/>
    <Home/>
    <Skills/>
    <Projects/>
    {/* <Try/> */}
    <Experience/>
    <Contact/>
    <Footer/>
   </div>
  );
}

export default App;
